import React from "react";
import { CtaButton } from "./CtaButton";
export function ClosingSection() {
  return <section className="section wash closing" data-id="element-19" data-mp="otc9r4h0nb1a">
      <div className="shell" data-id="element-20" data-mp="oundj4agoise">
        <h2 data-id="element-21" data-mp="12su0vqhsb0dt">
          Have a plan for the next
          <br data-id="element-22" data-mp="12tmz232oghkc" />
          <span data-id="element-23" data-mp="12ueundw9yfam">“we need to work on this.”</span>
        </h2>
        <p data-id="element-24" data-mp="xt8yt77bibwv">Choose the conversation. Review the session. Help your team practice a more useful response.</p>
        <CtaButton href="#offer-details" data-id="element-25" data-mp="1cq84gpilzuop">Get the complete kit — $27</CtaButton>
        <p className="cta-note" data-id="element-26" data-mp="17s6ju05jbnb4">10 sessions + 5 bonuses · USD · One-time payment</p>
      </div>
    </section>;
}